import { Directive } from '@angular/core';

@Directive({
  selector: '[equalize]',
})
export class EqualizeDirective {
}





// WEBPACK FOOTER //
// ./src/app/helper/equalizer/equalize.directive.ts